<template>
	<window-view title="Todo" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.deadline" label="Deadline" />
				</grid-view>
				<grid-view>
					<input-view type="text" v-model="m.message" label="Todo" :height="200" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import TodoModel from '../../../model/todo';

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				m: TodoModel.model()
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};
		}
	}
</script>

<style lang="scss" scoped>

</style>